// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","195":"a23dc3fe43f12953ac81","243":"307c1cf31df043fbcfea","595":"f7776ac79a7da92f941a","658":"c4d379860a7f1bc60a9f","871":"9fec12032046920a6ff9"}[chunkId] + ".bundle.js";
};